import { useTranslation } from 'react-i18next';
import { WREG_TOTAL_STEPS } from './wregSteps';

type Props = {
  n: number;
  total?: number;
};

const WregPhase = ({ n, total = WREG_TOTAL_STEPS }: Props) => {
  const { t } = useTranslation();
  const step = Math.min(total, Math.max(1, n));
  const label = t('wreg.phasebar', { n: step, total });
  return (
    <div
      className="rg-phasebar c-bar"
      role="progressbar"
      aria-valuemin={1}
      aria-valuemax={total}
      aria-valuenow={step}
      aria-label={label}
    >
      <div className="rg-phasebar-step">{label}</div>
      <div className="c-bar-track">
        <div className="c-bar-fill" style={{ width: `${(step / total) * 100}%` }} />
      </div>
    </div>
  );
};

export { WregPhase };
